const en_payment_debit = {
    "": "accounts receivable",
    add: "add receivable",
    detail: "receivable detail",
    info_title: "This page is used to process invoice payments.",
    inv_pay: "paid invoice",
    inv_remainning: "remaining invoice",
    total_inv: "total invoice",
    total_selected: "total selected",

    label: {
        bank: "bank account",
        cut: "discount",
        giro_bank: "giro bank name",
        giro_date: "giro clearance date",
        giro_info: "giro clearance description",
        giro_no: "giro number",
        nominal: "payment amount",
        pay: "pay",
        return: "return",
        select_invoice: "select invoice",
        selected_invoice: "selected invoice",
    },

    error: {
        account_bank: "Bank account cannot be empty.",
        account_cut: "Discount cannot be empty.",
        create: "Failed to process payment.",
        giro: "Giro number cannot be empty.",
        inv_min: "At least 1 invoice must be selected.",
        pay_method: "Payment method cannot be empty.",
        pay_nominal: "Payment amount cannot be empty.",
        retur: "Return cannot be empty.",
    },

    success: {
        create: "Payment processed successfully.",
    },
}

export default en_payment_debit;